<div class="ecb-voc-registration-page">


  <!-- ===================================================== -->
  <!-- PAGE LOADING -->
  <!-- ===================================================== -->

  <div class="ecb-voc-page-message ecb-voc-loading-message" *ngIf="isLoading">

    <span class="spinner-border spinner-border-sm"></span>

    <span>
      Loading registration details...
    </span>

  </div>


  <div class="ecb-voc-registration-container" *ngIf="!isLoading && enquiryBody">


    <!-- =================================================== -->
    <!-- MAIN HEADER -->
    <!-- =================================================== -->

    <div class="ecb-voc-registration-header">

      <div class="ecb-voc-registration-header-icon">

        <i class="bi bi-clipboard-check"></i>

      </div>


      <div class="ecb-voc-registration-header-content">

        <span class="ecb-voc-registration-label">
          Training Registration
        </span>

        <h1>
          Participant Registration Details
        </h1>

        <p *ngIf="clientType === 'CORPORATE'">
          Review the existing company and participant information
          and complete the required registration details below.
        </p>

        <p *ngIf="clientType === 'GENERAL'">
          Review your selected training and complete the required
          participant registration details below.
        </p>

      </div>


      <div class="ecb-voc-enquiry-reference">

        <span>
          Enquiry Reference
        </span>

        <strong>
          #ENQ-00{{ enquiryId }}
        </strong>

      </div>

    </div>



    <!-- =================================================== -->
    <!-- COMPANY DETAILS - SHOWN ONLY ONCE -->
    <!-- =================================================== -->

    <section class="ecb-voc-form-card" *ngIf="clientType === 'CORPORATE'">


      <!-- Section Header -->
      <div class="ecb-voc-card-header">

        <div class="ecb-voc-card-header-title">

          <div class="ecb-voc-card-icon">

            <i class="bi bi-building"></i>

          </div>


          <div>

            <h2>
              Company Details
            </h2>

            <p>
              Company and primary contact information
            </p>

          </div>

        </div>

      </div>


      <!-- Section Body -->
      <div class="ecb-voc-card-body">

        <div class="row g-4">


          <!-- Company Name -->
          <div class="col-12 col-md-6">

            <div class="ecb-voc-form-group">

              <label>
                Company Name
                <span>*</span>
              </label>

              <input type="text" class="form-control" [maxlength]="100" [(ngModel)]="companyForm.companyName"
                name="companyName" placeholder="Enter company name">

            </div>

          </div>


          <!-- ABN -->
          <div class="col-12 col-md-6">

            <div class="ecb-voc-form-group">

              <label>
                ABN
              </label>

              <input [maxlength]="20" type="text" class="form-control" [(ngModel)]="companyForm.abn" name="companyAbn"
                placeholder="Enter ABN">

            </div>

          </div>


          <!-- Contact Person -->
          <div class="col-12 col-md-6">

            <div class="ecb-voc-form-group">

              <label>
                Contact Person

              </label>

              <input type="text" [maxlength]="100" class="form-control" [(ngModel)]="companyForm.contactPerson"
                name="companyContactPerson" placeholder="Enter contact person">

            </div>

          </div>


          <!-- Position -->
          <div class="col-12 col-md-6">

            <div class="ecb-voc-form-group">

              <label>
                Position
              </label>

              <input type="text" [maxlength]="50" class="form-control" [(ngModel)]="companyForm.position"
                name="companyPosition" placeholder="Enter position">

            </div>

          </div>


          <!-- Email -->
          <div class="col-12 col-md-6">

            <div class="ecb-voc-form-group">

              <label>
                Email Address
                <span>*</span>
              </label>

              <input type="email" class="form-control" [maxlength]="100" [(ngModel)]="companyForm.companyEmail" readonly
                name="companyEmail" placeholder="Enter email address" #companyEmailCtrl="ngModel" appEmailValidator>

            </div>
            <div class="text-danger" *ngIf="companyEmailCtrl.invalid &&
         (companyEmailCtrl.dirty || companyEmailCtrl.touched)">

              <span *ngIf="companyEmailCtrl.errors?.['invalidEmail']">
                Please enter a valid email address.
              </span>

            </div>

          </div>


          <!-- Phone -->
          <div class="col-12 col-md-6">

            <div class="ecb-voc-form-group">

              <label>
                Phone Number
                <!--   <span>*</span> -->
              </label>

              <input type="tel" class="form-control" [maxlength]="10" [(ngModel)]="companyForm.phone"
                name="companyPhone" placeholder="Enter phone number">

            </div>

          </div>

        </div>

      </div>

    </section>



    <!-- =================================================== -->
    <!-- PARTICIPANT HEADING -->
    <!-- =================================================== -->

    <div class="ecb-voc-participant-section-heading">

      <div>

        <h2>
          Participant Details
        </h2>

        <p>
          Complete the information for each participant included
          in this training enquiry.
        </p>

      </div>


      <div class="ecb-voc-participant-total">

        {{ participants.length }}

        Participant{{ participants.length === 1 ? '' : 's' }}

      </div>

    </div>



    <!-- =================================================== -->
    <!-- PARTICIPANTS -->
    <!-- =================================================== -->

    <div class="ecb-voc-participant-card" *ngFor="
        let participant of participants;
        let participantIndex = index
      ">


      <!-- ================================================= -->
      <!-- PARTICIPANT HEADER -->
      <!-- ================================================= -->

      <div class="ecb-voc-participant-header">

        <div class="ecb-voc-participant-identity">

          <div class="ecb-voc-participant-number">

            {{ participantIndex + 1 }}

          </div>


          <div>

            <span>
              Participant {{ participantIndex + 1 }}
            </span>

            <h3>

              {{
              participant.firstName ||
              participant.lastName
              ? (
              participant.firstName +
              ' ' +
              participant.lastName
              )
              : participant.fullName
              }}

            </h3>

          </div>

        </div>


        <div class="ecb-voc-participant-progress">

          Registration Details

        </div>

      </div>



      <!-- ================================================= -->
      <!-- TRAINING REQUESTED -->
      <!-- ================================================= -->

      <div class="ecb-voc-sub-section">

        <div class="ecb-voc-sub-section-header">

          <div>

            <i class="bi bi-mortarboard"></i>

            <span>
              Training Requested
            </span>

          </div>

        </div>


        <div class="ecb-voc-training-summary">

          <!-- UOC -->
          <div class="ecb-voc-training-category" *ngIf="participant.uocCourses?.length">

            <div class="ecb-voc-training-category-label">

              UOC

            </div>


            <div class="ecb-voc-training-items">

              <div class="ecb-voc-training-item" *ngFor="let course of participant.uocCourses">

                <strong>
                  {{ course.courseCode }}
                </strong>

                <span>
                  {{ course.courseTitle }}
                </span>

              </div>

            </div>

          </div>


          <!-- VOC -->
          <div class="ecb-voc-training-category" *ngIf="participant.vocCourses?.length">

            <div class="
                ecb-voc-training-category-label
                ecb-voc-training-category-voc
              ">

              VOC

            </div>


            <div class="ecb-voc-training-items">

              <div class="ecb-voc-training-item" *ngFor="let voc of participant.vocCourses">

                <strong>
                  {{ voc.vocCode }}
                </strong>

                <span>
                  {{ voc.vocName }}
                </span>

              </div>

            </div>

          </div>



          <!-- COA -->
          <div class="ecb-voc-training-category" *ngIf="participant.coaCourses?.length">

            <div class="ecb-voc-training-category-label">

              COA

            </div>


            <div class="ecb-voc-training-items">

              <div class="ecb-voc-training-item" *ngFor="let course of participant.coaCourses; let i = index">

                <strong>
                  COA {{ i + 1 }}
                </strong>

                <span>
                  {{ course.courseName }}
                </span>

              </div>

            </div>

          </div>


        </div>

      </div>



      <!-- ================================================= -->
      <!-- PERSONAL DETAILS -->
      <!-- ================================================= -->

      <div class="ecb-voc-sub-section">

        <div class="ecb-voc-sub-section-header">

          <div>

            <i class="bi bi-person"></i>

            <span>
              Personal Details
            </span>

          </div>

        </div>


        <div class="ecb-voc-sub-section-body">

          <div class="row g-4">


            <!-- First Name -->
            <div class="col-12 col-md-6">

              <div class="ecb-voc-form-group">

                <label>
                  First Name
                  <span>*</span>
                </label>

                <input type="text" class="form-control" [(ngModel)]="participant.firstName"
                  [name]="'firstName_' + participantIndex" placeholder="Enter first name">

              </div>

            </div>


            <!-- Last Name -->
            <div class="col-12 col-md-6">

              <div class="ecb-voc-form-group">

                <label>
                  Last Name
                  <span>*</span>
                </label>

                <input type="text" class="form-control" [(ngModel)]="participant.lastName"
                  [name]="'lastName_' + participantIndex" placeholder="Enter last name">

              </div>

            </div>


            <!-- DOB -->
            <div class="col-12 col-md-4">

              <div class="ecb-voc-form-group">

                <label>
                  Date of Birth

                </label>

                <input type="date" class="form-control" [(ngModel)]="participant.dateOfBirth"
                  [name]="'dateOfBirth_' + participantIndex">

              </div>

            </div>


            <!-- Gender -->
            <div class="col-12 col-md-4">

              <div class="ecb-voc-form-group">

                <label>
                  Gender
                </label>

                <select class="form-select" [(ngModel)]="participant.gender" [name]="'gender_' + participantIndex">

                  <option value="">
                    Select gender
                  </option>

                  <option value="MALE">
                    Male
                  </option>

                  <option value="FEMALE">
                    Female
                  </option>

                  <option value="OTHER">
                    Other
                  </option>

                  <option value="PREFER_NOT_TO_SAY">
                    Prefer not to say
                  </option>

                </select>

              </div>

            </div>


            <!-- Mobile -->
            <div class="col-12 col-md-4">

              <div class="ecb-voc-form-group">

                <label>
                  Mobile Number

                </label>

                <input type="tel" class="form-control" [maxlength]="10" [(ngModel)]="participant.mobileNumber"
                  [name]="'mobileNumber_' + participantIndex" placeholder="Enter mobile number">

              </div>

            </div>


            <!-- Participant Email -->
            <div class="col-12">

              <div class="ecb-voc-form-group">

                <label>
                  Participant Email Address
                  <span>*</span>
                </label>

                <input type="email" class="form-control" [(ngModel)]="participant.emailAddress"
                  [name]="'participantEmail_' + participantIndex" placeholder="Enter participant email address"
                  maxlength="100" appEmailValidator #participantEmailCtrl="ngModel">

              </div>
              <div class="text-danger" *ngIf="participantEmailCtrl.invalid &&
         (participantEmailCtrl.dirty || participantEmailCtrl.touched)">

                <span *ngIf="participantEmailCtrl.errors?.['invalidEmail']">
                  Please enter a valid participant email address.
                </span>

              </div>

            </div>

          </div>

        </div>

      </div>



      <!-- ================================================= -->
      <!-- QUALIFICATION -->
      <!-- ================================================= -->

      <div class="ecb-voc-sub-section">

        <div class="ecb-voc-sub-section-header">

          <div>

            <i class="bi bi-award"></i>

            <span>
              Existing Qualification / Competency
            </span>

          </div>

        </div>


        <div class="ecb-voc-sub-section-body">

          <div class="row g-4">


            <!-- Qualification -->
            <div class="col-12 col-md-6">

              <div class="ecb-voc-form-group">

                <label>
                  Relevant Qualification / Competency
                </label>

                <input type="text" class="form-control" [(ngModel)]="participant.relevantQualification" maxlength="50"
                  [name]="'qualification_' + participantIndex" placeholder="Enter qualification">

              </div>

            </div>


            <!-- Certificate No -->
            <div class="col-12 col-md-6">

              <div class="ecb-voc-form-group">

                <label>
                  Certificate Number
                </label>

                <input type="text" class="form-control" [(ngModel)]="
                    participant.qualificationCertificateNumber
                  " maxlength="50" [name]="'certificateNumber_' + participantIndex"
                  placeholder="Enter certificate number">

              </div>

            </div>


            <!-- Organisation -->
            <div class="col-12 col-md-6">

              <div class="ecb-voc-form-group">

                <label>
                  Issuing RTO / Organisation
                </label>

                <input type="text" class="form-control" [(ngModel)]="participant.issuingOrganisation" maxlength="50"
                  [name]="'issuingOrganisation_' + participantIndex" placeholder="Enter organisation">

              </div>

            </div>


            <!-- Date -->
            <div class="col-12 col-md-6">

              <div class="ecb-voc-form-group">

                <label>
                  Date Issued / Expiry
                </label>
                <input type="date" class="form-control" [(ngModel)]="participant.dateIssuedExpiry"
                  [name]="'dateIssuedExpiry_' + participantIndex">

              </div>

            </div>



            <!-- Certificate Available -->
            <div class="col-12 col-md-6">

              <div class="ecb-voc-form-group">

                <label>
                  Certificate Available
                </label>


                <div class="ecb-voc-choice-group">

                  <label>

                    <input type="radio" [name]="'certificateAvailable_' + participantIndex" [value]="true"
                      [(ngModel)]="participant.certificateAvailable" (ngModelChange)="
                        onCertificateAvailableChange(participantIndex)
                      ">

                    <span>
                      Yes
                    </span>

                  </label>


                  <label>

                    <input type="radio" [name]="'certificateAvailable_' + participantIndex" [value]="false"
                      [(ngModel)]="participant.certificateAvailable" (ngModelChange)="
                        onCertificateAvailableChange(participantIndex)
                      ">

                    <span>
                      No
                    </span>

                  </label>

                </div>

              </div>

            </div>



            <!-- Certificate Upload -->
            <div class="col-12 col-md-6" *ngIf="participant.certificateAvailable === true">

              <div class="ecb-voc-form-group">

                <label>
                  Certificate Document
                </label>


                <input #certificateFileInput type="file"
                  accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp" hidden
                  [disabled]="participant.isCertificateUploading" (change)="
                    onCertificateFileSelected(
                      $event,
                      participantIndex
                    )
                  ">


                <div class="ecb-voc-file-upload-box">


                  <button type="button" class="ecb-voc-upload-button" [disabled]="participant.isCertificateUploading"
                    (click)="certificateFileInput.click()">

                    <ng-container *ngIf="!participant.isCertificateUploading">

                      <i class="bi bi-cloud-arrow-up"></i>

                      {{
                      participant.certificateFileName
                      ? 'Replace Document'
                      : 'Upload File'
                      }}

                    </ng-container>


                    <ng-container *ngIf="participant.isCertificateUploading">

                      <span class="
                          spinner-border
                          spinner-border-sm
                        ">
                      </span>

                      Uploading...

                    </ng-container>

                  </button>


                  <div class="ecb-voc-uploaded-file" *ngIf="participant.certificateFileName">

                    <i class="bi bi-award"></i>


                    <div>

                      <strong>
                        {{ participant.certificateFileName }}
                      </strong>

                      <span *ngIf="participant.certificateFileUrl">

                        Upload complete

                      </span>

                    </div>

                  </div>


                  <div class="ecb-voc-upload-error" *ngIf="participant.certificateUploadError">

                    {{ participant.certificateUploadError }}

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>



      <!-- ================================================= -->
      <!-- IDENTITY -->
      <!-- ================================================= -->

      <div class="ecb-voc-sub-section ecb-identity-section" [class.is-reading]="participant.isIdReading">

        <div class="ecb-voc-sub-section-header">

          <div>

            <i class="bi bi-person-vcard"></i>

            <span>
              Identity Verification
            </span>

          </div>

        </div>


        <div class="ecb-voc-sub-section-body">


          <!-- ========================================= -->
          <!-- OCR READING -->
          <!-- ========================================= -->

          <div class="ecb-identity-reading" *ngIf="participant.isIdReading">

            <span class="spinner-border spinner-border-sm">
            </span>

            <div>

              <strong>
                Reading ID details...
              </strong>

              <span>
                Detecting document information...
                {{ participant.idOcrProgress }}%
              </span>

            </div>

          </div>


          <div class="row g-4">


            <!-- ======================================= -->
            <!-- ID TYPE -->
            <!-- ======================================= -->

            <div class="col-12 col-md-4">

              <div class="col-12 col-md-12">
                <div class="ecb-voc-form-group">

                  <label>
                    ID Type
                  </label>

                  <select class="form-select" [(ngModel)]="participant.idType" [name]="'idType_' + participantIndex"
                    [disabled]="participant.isIdReading">

                    <option value="">
                      Select ID type
                    </option>

                    <option value="DRIVER_LICENCE">
                      Driver Licence
                    </option>

                    <option value="PASSPORT">
                      Passport
                    </option>

                    <option value="PROOF_OF_AGE">
                      Proof of Age
                    </option>

                    <option value="OTHER">
                      Other
                    </option>

                  </select>

                </div>


              </div>

              <!-- ======================================= -->
              <!-- ID NUMBER -->
              <!-- ======================================= -->

              <div class="col-12 col-md-12 mt-2">

                <div class="ecb-voc-form-group">

                  <label>
                    ID Number
                  </label>

                  <input type="text" class="form-control" [(ngModel)]="participant.idNumber" maxlength="20"
                    [name]="'idNumber_' + participantIndex" placeholder="Enter ID number" [disabled]="
              !participant.idType ||
              participant.isIdReading
            ">

                </div>

              </div>


              <!-- ======================================= -->
              <!-- ID EXPIRY -->
              <!-- ======================================= -->

              <div class="col-12 col-md-12 mt-2">

                <div class="ecb-voc-form-group">

                  <label>
                    Expiry Date
                  </label>

                  <input type="date" class="form-control" [(ngModel)]="participant.idExpiryDate"
                    [name]="'idExpiryDate_' + participantIndex" [disabled]="
              !participant.idType ||
              participant.isIdReading
            ">

                </div>

              </div>

            </div>



            <!-- ======================================= -->
            <!-- ID UPLOAD -->
            <!-- ======================================= -->

            <div class="col-12 col-md-8">

              <div class="ecb-voc-form-group">

                <label>
                  ID Document
                </label>


                <input #idFileInput type="file"
                  accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp" hidden [disabled]="
              !participant.idType ||
              participant.isIdUploading ||
              participant.isIdReading
            " (change)="
              onIdFileSelected(
                $event,
                participantIndex
              )
            ">


                <div class="ecb-voc-file-upload-box">


                  <!-- ================================= -->
                  <!-- UPLOAD BUTTON -->
                  <!-- ================================= -->

                  <button type="button" class="ecb-voc-upload-button" [disabled]="
                !participant.idType ||
                participant.isIdUploading ||
                participant.isIdReading
              " (click)="idFileInput.click()">


                    <!-- No ID type -->

                    <ng-container *ngIf="
                  !participant.idType &&
                  !participant.isIdUploading &&
                  !participant.isIdReading
                ">

                      <i class="bi bi-person-vcard"></i>

                      Select ID Type First

                    </ng-container>


                    <!-- Normal -->

                    <ng-container *ngIf="
                  participant.idType &&
                  !participant.isIdUploading &&
                  !participant.isIdReading
                ">

                      <i class="bi bi-cloud-arrow-up"></i>

                      {{
                      participant.idFileName
                      ? 'Replace ID Document'
                      : 'Upload ID File'
                      }}

                    </ng-container>


                    <!-- Reading -->

                    <ng-container *ngIf="participant.isIdReading">

                      <span class="
                    spinner-border
                    spinner-border-sm
                  ">
                      </span>

                      Reading ID...

                    </ng-container>


                    <!-- Uploading -->

                    <ng-container *ngIf="
                  participant.isIdUploading &&
                  !participant.isIdReading
                ">

                      <span class="
                    spinner-border
                    spinner-border-sm
                  ">
                      </span>

                      Uploading...

                    </ng-container>

                  </button>


                  <!-- ================================= -->
                  <!-- FILE INFORMATION -->
                  <!-- ================================= -->

                  <div class="ecb-voc-uploaded-file" *ngIf="participant.idFileName">

                    <i class="bi bi-person-vcard"></i>

                    <div>

                      <strong>
                        {{ participant.idFileName }}
                      </strong>


                      <span *ngIf="
                    participant.isIdReading
                  ">

                        <span class="
                      spinner-border
                      spinner-border-sm
                    ">
                        </span>

                        Reading document...

                      </span>


                      <span *ngIf="
                    participant.idFileUrl &&
                    !participant.isIdReading
                  ">

                        <i class="bi bi-check-circle-fill"></i>

                        Upload complete

                      </span>

                    </div>

                  </div>


                  <!-- ================================= -->
                  <!-- ERROR -->
                  <!-- ================================= -->

                  <div class="ecb-voc-upload-error" *ngIf="participant.idUploadError">

                    <i class="bi bi-exclamation-circle"></i>

                    {{ participant.idUploadError }}

                  </div>

                </div>

              </div>

            </div>





          </div>

        </div>

      </div>


      <!-- ================================================= -->
      <!-- DECLARATION -->
      <!-- ================================================= -->

      <div class="ecb-voc-sub-section">

        <div class="ecb-voc-sub-section-header">

          <div>

            <i class="bi bi-shield-check"></i>

            <span>
              Declaration
            </span>

          </div>

        </div>


        <div class="ecb-voc-sub-section-body">


          <div class="ecb-voc-declaration-list">


            <label class="ecb-voc-declaration-item">

              <input type="checkbox" [(ngModel)]="participant.declarationTrueCorrect"
                [name]="'declarationOne_' + participantIndex">


              <span>

                I confirm that the information provided in
                this registration form is true and correct.

              </span>

            </label>


            <label class="ecb-voc-declaration-item">

              <input type="checkbox" [(ngModel)]="participant.declarationAdditionalEvidence"
                [name]="'declarationTwo_' + participantIndex">


              <span>

                I understand that additional evidence or
                information may be requested before assessment.

              </span>

            </label>


            <label class="ecb-voc-declaration-item">

              <input type="checkbox" [(ngModel)]="participant.declarationPracticalCompetency"
                [name]="'declarationThree_' + participantIndex">


              <span>

                I understand that the VOC assessment may require
                demonstration of practical competency.

              </span>

            </label>

          </div>


          <div class="row g-4 mt-1">


            <!-- Applicant -->
            <div class="col-12 col-md-4">

              <div class="ecb-voc-form-group">

                <label>
                  Applicant Name
                </label>

                <input type="text" class="form-control" [(ngModel)]="participant.applicantName" maxlength="50"
                  [name]="'applicantName_' + participantIndex">

              </div>

            </div>


            <!-- Signature -->
            <div class="col-12">

              <div class="ecb-voc-form-group">

                <label>
                  Signature
                </label>

                <app-choose-esignature [(signature)]="participant.signature" [defaultFullName]="
        participant.applicantName ||
        (participant.firstName + ' ' + participant.lastName)
      ">
                </app-choose-esignature>

              </div>

            </div>
            <!--  <div class="col-12 col-md-4">

              <div class="ecb-voc-form-group">

                <label>
                  Signature
                </label>

                <input type="text" class="form-control" [(ngModel)]="participant.signature"
                  [name]="'signature_' + participantIndex" placeholder="Enter applicant name">

              </div>

            </div> -->


            <!-- Declaration Date -->
            <div class="col-12 col-md-4">

              <div class="ecb-voc-form-group">

                <label>
                  Date
                </label>

                <input type="date" class="form-control" [(ngModel)]="participant.declarationDate"
                  [name]="'declarationDate_' + participantIndex" [disabled]="true">

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>



    <!-- ===================================================== -->
    <!-- ERROR -->
    <!-- ===================================================== -->

    <div class="alert alert-danger ecb-voc-page-message" *ngIf="errorMessage">

      <i class="bi bi-exclamation-circle-fill"></i>

      {{ errorMessage }}

    </div>


    <!-- ===================================================== -->
    <!-- SUCCESS -->
    <!-- ===================================================== -->

    <div class="alert alert-success ecb-voc-page-message" *ngIf="successMessage">

      <i class="bi bi-check-circle-fill"></i>

      {{ successMessage }}

    </div>



    <!-- =================================================== -->
    <!-- FINAL SUBMISSION -->
    <!-- =================================================== -->

    <div class="ecb-voc-submit-card">


      <div class="ecb-voc-submit-info">

        <i class="bi bi-info-circle"></i>


        <div>

          <strong>
            Review before submitting
          </strong>

          <span>
            Please confirm all participant information and uploaded
            documents are correct.
          </span>

        </div>

      </div>


      <button type="button" class="btn ecb-voc-submit-button" [disabled]="
          isSubmitting ||
          hasUploadingFiles()
        " (click)="submitRegistration()">


        <ng-container *ngIf="!isSubmitting">

          <i class="bi bi-check-circle"></i>

          Submit Registration

        </ng-container>


        <ng-container *ngIf="isSubmitting">

          <span class="
              spinner-border
              spinner-border-sm
            ">
          </span>

          Submitting...

        </ng-container>

      </button>

    </div>

  </div>


  <div class="ecb-registration-error-card" *ngIf="!isLoading && alreadySubmitted">

    <div class="ecb-registration-state-icon">
      <i class="bi bi-check-circle"></i>
    </div>

    <h3>
      The form has already been submitted
    </h3>

    <p>
      This registration form has already been completed and submitted.
    </p>

  </div>

  <div class="ecb-registration-error-card" *ngIf="!isLoading && errorMessage && alreadySubmitted">

    <div class="ecb-registration-state-icon error">

      <i class="bi bi-exclamation-triangle"></i>

    </div>

    <h3>
      Unable to load registration
    </h3>

    <p>
      {{ errorMessage }}
    </p>

  </div>
</div>